<div *ngIf="pip || popin" class="close-button"><i (click)="close()" class="fa fa-times"></i></div>
<div id="{{playerId}}-video-container"></div>
